import api from "../../../components/axiosComp";

/** List rules for a ground */
export async function listPricing(groundId) {
  const { data } = await api.get(`/api/superAdmin/grounds/${groundId}/pricing`);
  return Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data)
      ? data
      : [];
}

/** Create rule for ground */
export async function createPricing(groundId, payload) {
  const { data } = await api.post(
    `/api/superAdmin/grounds/${groundId}/pricing`,
    payload,
  );
  return data;
}

/** Update rule */
export async function updatePricing(ruleId, payload) {
  const { data } = await api.put(`/api/superAdmin/pricing/${ruleId}`, payload);
  return data;
}

/** Delete (soft) rule */
export async function deletePricing(ruleId) {
  const { data } = await api.delete(`/api/superAdmin/pricing/${ruleId}`);
  return data;
}
